import HeuristicsEditorController from './heuristicsEditorController';

const heuristicsEditorComponent = {
    template: require('./heuristicsEditorView.html'),
    controller: HeuristicsEditorController,
    bindings: {
        curraspectname: '=',
        state: '<'
    }
};

export default heuristicsEditorComponent;


// WEBPACK FOOTER //
// ./src/app/pages/manageSkills/heuristics/heuristicsEditorComponent.js